import { render, staticRenderFns } from "./task_book.vue?vue&type=template&id=270714b0&scoped=true"
import script from "./task_book.vue?vue&type=script&lang=js"
export * from "./task_book.vue?vue&type=script&lang=js"
import style0 from "./task_book.vue?vue&type=style&index=0&id=270714b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270714b0",
  null
  
)

export default component.exports